import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FloatRequest, floatState } from '../../components/float-management/types';
import { RootState } from '../store';
import floatRequestService from '../../API/floatRequestApi';
import { toast } from 'react-toastify';

const initialState: floatState = {
	data: [],
	meta: undefined,
	isLoading: false,
};

export const asyncRetrieveAllFloatRequest = createAsyncThunk<
	{ data: FloatRequest[]; meta: any },
	string | undefined,
	{ state: RootState; rejectValue: string }
>('floatRequests/retrieveAll', async (query, thunkApi) => {
	try {
		const res = await floatRequestService.retrieveFloatRequest(query);
		return { data: res.data.data, meta: res.data.meta };
	} catch (error) {
		const errorMessage =
			(error.res && error.res.data && error.res.data.message && error.res.message) ||
			error.toString();
		toast.error(errorMessage);
		return thunkApi.rejectWithValue(errorMessage);
	}
});

const floatRequestSlice = createSlice({
	name: 'floatRequests',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(asyncRetrieveAllFloatRequest.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				asyncRetrieveAllFloatRequest.fulfilled,
				(state, action: PayloadAction<{ data: FloatRequest[]; meta: any }>) => {
					state.isLoading = false;
					state.data = action.payload.data;
					state.meta = action.payload.meta;
				},
			)
			.addCase(asyncRetrieveAllFloatRequest.rejected, (state) => {
				state.isLoading = false;
			});
	},
});

export const selectedFloats = (state: RootState) => state.floatRequest;
export default floatRequestSlice.reducer;
